import React from "react";
import { useHistory } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../utils/getServiceNameWithNickname";
import MasterRefillingCreateForm from "../../elements/masterBalances/MasterRefillingCreateForm";
import DefaultButton from "../../styles/materialButtonStyle";

import { StyledCol, StyledTableRow } from "../../styles/styledTable";

const MasterBalancesItem = ({ t, value, setFetch }) => {

  const history = useHistory();

  // Logic hasn't changed as there are problems with the modal window
  const handleRedirect = (e, id) => {
    if (e.target.dataset?.action === "details") {
      history.push("/master-balances/" + id + "/history");
    }
  }

  return (
    <StyledTableRow
      scroll="auto"
      col="4"
      className="master-balances-table__row"
      onClick={(e) => handleRedirect(e, value.id)}
      data-action="details"
      cursor="pointer"
    >
      <StyledCol data-action="details">
        {value.currency.asset}
      </StyledCol>
      <StyledCol data-action="details">
        {getServiceNameWithNickname(value.service.name, value.service.nickname)}
      </StyledCol>
      <StyledCol data-action="details">
        {value.amount}
      </StyledCol>
      <StyledCol className="master-balances-table__actions">
        <DefaultButton
          color="transparent"
          border="success"
          data-action="details"
          onClick={() => history.push("/master-balances/" + value.id + "/history")}
        >
          {t("actions.details")}
        </DefaultButton>
        <MasterRefillingCreateForm
          t={t}
          balanceId={value.id}
          setFetch={setFetch}
        />
      </StyledCol>
    </StyledTableRow>
  );
};

export default MasterBalancesItem;